import {createContext} from 'react';
import {MaintenanceActions, MaintenanceState} from './types.js';

export const MaintenanceContext = createContext<MaintenanceState>(null as unknown as MaintenanceState);

export const MaintenanceDispatchContext = createContext<React.Dispatch<MaintenanceActions>>(null as unknown as React.Dispatch<MaintenanceActions>);
